module.exports = __webpack_public_path__ + "img/05cf3da.jpg";